export default __webpack_public_path__ + "static/media/arrow-up.bb39a878.svg";